'use strict';

/**
 * Layout view for filter modals
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var FilterComponentView = LayoutView.extend({
    name: '',

    className: function() { return 'filter' + ' filter-' + this.getOption('type') + ' filter-' + this.getOption('name'); },

    id: function() { return 'filter-' + this.getOption('name'); },

    onRender: function() {
        this.setFilters(this.getActiveFilterForCompent());
    },

    getName: function() {
        return _.camelcase(this.getOption('name'));
    },

    getDisplayName: function() {
        return this.getOption('displayName');
    },

    getTitle: function() {
        return this.getOption('title') || this.getDisplayName() || '';
    },

    getModelAttribute: function() {
        return this.getOption('modelAttribute') || this.getName();
    },

    getFilters: function() {
        return [];
    },

    setFilters: function() {
        console.log('Please implement FilterComponentView:setFilters() for: ' + this.getOption('name'));
    },

    resetFilters: function() {
        console.log('Please implement FilterComponentView:resetFilters() for: ' + this.getOption('name'));
    },

    change: function(event) {
        this.setFilters(_.pluck(this.getFilters(), 'value').join(','));
        App.vent.trigger('filter:update');
    },

    getFilterString: function() {
        var filters = _.pluck(this.getFilters(), 'value');

        if (filters.length) {
            return this.getName() + '/' + filters.join(',');
        }

        return '';
    },

    getActiveFilterForCompent: function() {
        var activeFilters = this.getOption('activeFilters');

        if (_.isString(activeFilters)) {
            var filter = activeFilters.split('/');
            if (filter.length % 2 === 0) {
                for(var i = 0; i < filter.length; i++) {
                    if (i % 2 === 0) {
                        var filterKey = filter[i];
                        var requestedValue = filter[i + 1];

                        if (filterKey === this.getName()) {
                            return requestedValue;
                        }
                    }
                }
            }
        }

        return '';
    },

    //implement in filter
    getFilterValueDisplayName: function(value) {
        return value;
    },

    getFilterValueDisplayNames: function(values) {
        return values.map(this.getFilterValueDisplayName.bind(this)).join(', ');
    },

    renderFilterButton: function() {
        var html = '';

        var filters = this.getFilters();
        var values = _.pluck(filters, 'value');

        if (filters.length) {
            //@todo put into template
            html += '<div class="active-filter">';
            html += '  <a href="#' + this.id() + '" title="' + App.t('collection::objects:filter:button:go-to-filter-definition:title') + '" data-action="goto-definition">';
            html += '    <label>' + this.getDisplayName() + ':</label> ' + this.getFilterValueDisplayNames(values);
            html += '  </a>';
            html += '  <button data-action="clear-filter" data-filter-name="' + this.getOption('name') + '" title="' + App.t('collection::objects:filter:button:remove-filter:title') + '"></button>';
            html += '</div>';
        }

        return html;
    },

    renderListFilterButton: function() {
        var html = '';

        var filters = this.getActiveFilterForCompent();
        var values = filters.split(',');

        if (filters.length) {
            html += '  <button class="btn-secondary" data-action="open-filter" data-filter-name="' + this.getOption('name') + '" title="' + App.t('collection::objects:filter:button:open-filter:title') + '">';
            html += '    <label>' + this.getDisplayName() + ':</label> ' + this.getFilterValueDisplayNames(values);
            html += '  </button>';
            html += '  <button class="btn-secondary remove-filter" data-action="clear-filter" data-filter-name="' + this.getOption('name') + '" title="' + App.t('collection::objects:filter:button:remove-filter:title') + '">';
            html +=     App.html.icon('close-light');
            html += '  </button>';
        }

        return html;
    },

    getSortedValues: function() {
        //implement sort logic in filter
    },

    getCommonValues: function(amount) {
        return _.first(this.getSortedValues(), amount);
    },
});

module.exports = FilterComponentView;